import { useCallback } from "react";
import { clearAccessToken, getWebAuth } from "@lib/auth0";
import { useScope } from "@state/scopeContext.lib";
import { getAnalytics } from "@lib/analytics";
import { clearUser } from "@helpers/auth";
import { useClearWorkspaceUserCache } from "./useClearWorkspaceUserCache";
import { useClearOrganizationUserCache } from "./useClearOrganizationUserCache";

export function useLogout() {
    const { clear } = useScope();
    const clearAllWorkspaceCache = useClearWorkspaceUserCache();
    const clearAllOrganizationCache = useClearOrganizationUserCache();

    return useCallback(() => {
        clearAccessToken();
        getWebAuth().logout({ returnTo: window.location.origin });
        getAnalytics()?.reset();
        clearAllWorkspaceCache();
        clearAllOrganizationCache();
        void clear();
        clearUser();
    }, [clear, clearAllWorkspaceCache, clearAllOrganizationCache]);
}
